import script from "./Videosd.vue?vue&type=script&setup=true&lang=js"
export * from "./Videosd.vue?vue&type=script&setup=true&lang=js"

import "./Videosd.vue?vue&type=style&index=0&id=aec3ae16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec3ae16"]])

export default __exports__